import buildRepository from 'eop-ui-core/utils/repository'
import store from '@/store'
import router from '@/router'
import { dialog } from 'eop-shared-components/plugins/dialog'
import edge from '@/api/edge'
import facility from '@/api/facility'
import notification from '@/api/notification'
import report from '@/api/report'
import { CLIENT_KEY, setServerTime } from '@/constants'
import { AUTH_API_URL, PORTAL_API_URL } from '@/constants/env'

const repository = buildRepository({
  baseURL: PORTAL_API_URL,
  refreshTokenURL: AUTH_API_URL.replace('pw', '_pw'),
  buildHeaders: () => {
    return {
      'X-CNSAMC-CLIENT-KEY': CLIENT_KEY,
      'X-CNSAMC-TENANT-SCOPE': 'Platform',
      'X-CNSAMC-TENANT-ID': 'eop',
      'X-CNSAMC-REFERRER': sessionStorage.getItem('referrer') || location.href,
    }
  },
  getUserAccount: () => store.getters['accounts/getUserAccount'],
  setUserAccount: (account) => store.dispatch('accounts/setUserAccount', account),
  setPending: (pending) => store.dispatch('system/setPending', pending),
  setServerTime,
  onError: async (message) => dialog.notify(message, { usid: 'ServerErrorMessage', title: '오류' }),
  signOut: async () => {
    await store.dispatch('system/setPending', false)
    await store.dispatch('accounts/setUserAccount', undefined)
    await dialog.notify('로그인 정보가 만료 되었습니다. 다시 로그인 하시기 바랍니다.', {
      usid: 'TokenExpired',
      onClose: () => {
        if (router.currentRoute.value.name !== 'SingleSignOn') {
          router.replace('/')
        }
      },
    })
  },
})

const api = {
  ...repository,
  edge,
  facility,
  notification,
  report,
}

export default api
